export enum SectionItemDataType {
  TPAWidget = 'TPAWidget',
}
